document.addEventListener("DOMContentLoaded", function () {
  const stockWrapper = document.querySelector('[data-stock-wrapper]');
  const stockMessage = document.querySelector('[data-stock-message]');

  function renderStock(available) {
    if (!stockMessage) return;
    stockMessage.innerHTML = available
      ? `<span>Availability:</span> <span class="text-success">In stock</span>`
      : `<span>Availability:</span> <span class="text-danger">Out of stock</span>`;
  }

  const initialAvailable = !!(stockWrapper && stockWrapper.dataset.currentAvailable === "true");
  if (stockMessage) renderStock(initialAvailable);

  function getVariantFromVariantSelects() {
    try {
      const vs = document.querySelector('variant-selects');
      if (vs?.dataset?.selectedVariant) return JSON.parse(vs.dataset.selectedVariant);
    } catch { }
    return null;
  }

  function getProductJSONScript() {
    const selectors = [
      'script[type="application/json"][data-product-json]',
      'script[type="application/json"][id^="ProductJson-"]',
      'script[type="application/json"]'
    ];
    for (const sel of selectors) {
      const script = document.querySelector(sel);
      if (!script) continue;
      const txt = (script.textContent || '').trim();
      if (txt.includes('"variants"')) {
        try { return JSON.parse(txt); } catch { }
      }
    }
    return null;
  }

  function getVariantFromInputId() {
    const idInput = document.querySelector('input[name="id"]');
    if (!idInput?.value) return null;
    const variantId = Number(idInput.value);
    const productJSON = getProductJSONScript();
    if (!productJSON) return null;
    const variants = productJSON.variants || productJSON.product?.variants || productJSON?.data?.product?.variants;
    if (!variants) return null;
    return variants.find(v => Number(v.id) === variantId || String(v.id) === String(variantId)) || null;
  }

  function inferFromAtcText(text) {
    if (!text) return null;
    const t = text.toLowerCase();
    if (t.includes('sold out') || t.includes('out of stock') || t.includes('unavailable')) return false;
    if (t.includes('add to cart') || t.includes('add to basket') || t.includes('buy now')) return true;
    return null;
  }

  function getCurrentVariant() {
    return getVariantFromVariantSelects() || getVariantFromInputId() || window.productSingleObject || window.productJson || null;
  }

  function findAtcTextSpan() {
    return document.querySelector('[id^="AddToCartText-"]') ||
           document.querySelector('button[name="add"] span') ||
           document.querySelector('.product-form__cart-submit span') ||
           null;
  }

  function handleVariantUpdate() {
    const variant = getCurrentVariant();
    if (variant?.available !== undefined) return renderStock(!!variant.available);
    const atcText = findAtcTextSpan();
    const inferred = atcText ? inferFromAtcText(atcText.textContent || atcText.innerText) : null;
    if (inferred !== null) renderStock(inferred);
  }

  const atcTextSpan = findAtcTextSpan();
  if (atcTextSpan) {
    const mo = new MutationObserver(handleVariantUpdate);
    mo.observe(atcTextSpan, { childList: true, characterData: true, subtree: true });
    handleVariantUpdate();
  }

  const idInput = document.querySelector('input[name="id"]');
  if (idInput) idInput.addEventListener('change', handleVariantUpdate);

  document.body.addEventListener('change', e => {
    if (e.target.closest('variant-selects') || e.target.matches('.single-option-selector, select')) {
      setTimeout(handleVariantUpdate, 50);
    }
  });

  document.addEventListener('variant:change', handleVariantUpdate);
});